<template>
  <p
    class="text-white w-6 h-4 my-auto text-center rounded items-center justify-center shadow-lg"
    :class="`${bgColor}`"
    style="padding-bottom: 2px; font-size: 0.75rem"
  >
    {{ abbr }}
  </p>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'

export default defineComponent({
  props: {
    status: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { isLightMode } = useConfigStatePresenter()

    const abbr = computed(() => {
      switch (props.status) {
        case 'COMPILEERROR':
          return 'CE'
        case 'WRONGANSWER':
          return 'WA'
        case 'TIMELIMIT':
          return 'TLE'
        case 'MEMORYLIMIT':
          return 'MLE'
        case 'ACCEPTED':
          return 'AC'
        case 'OUTPUTLIMIT':
          return 'OLE'
        case 'RUNTIMEERROR':
          return 'RE'
        case 'PRESENTATIONERROR':
          return 'PE'
        case 'RUNNING':
        default:
          return '...'
      }
    })
    const bgColor = computed(() => {
      switch (props.status) {
        case 'ACCEPTED':
          if (isLightMode()) return 'bg-accept'
          else return 'bg-teal-700'
        case 'COMPILEERROR':
        case 'WRONGANSWER':
        case 'TIMELIMIT':
        case 'MEMORYLIMIT':
        case 'OUTPUTLIMIT':
        case 'RUNTIMEERROR':
        case 'PRESENTATIONERROR':
          if (isLightMode()) return 'bg-reject'
          else return 'bg-red-800'
        default:
          if (isLightMode()) return 'bg-gray-400'
          else return 'bg-gray-700'
      }
    })

    return {
      abbr,
      bgColor
    }
  }
})
</script>

<style></style>
